<template>
  <div>
    <h1>Bind</h1>
    <img :src="graph_code_url">
  </div>
</template>

<script>
  import customerService from "@/services/customer-service.js"

export default {
  data () {
    return {
      code: this.$route.query.code || "",
      token: 'adsfa',
      graph_code_url: "",
    }
  },
  created () {
    // if (this.code) {
      // 有code就是登陆
    // } else if (token) {
      // 没有code判断token
    // } else {
      // 授权
    // }
  // customerService.getGraphCode().then((res) => {
  //   this.graph_code_url = res
  // })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customer/Bind.vue